import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Snapshot, SnapshotMarker } from 'types';

export const getMarkers = async ({
  snapshotId,
}: {
  snapshotId: number;
}): Promise<SnapshotMarker[]> => {
  const { data }: { data: Snapshot } = await axios.get(
    `/api/snapshots/${snapshotId}`
  );
  const { markers } = data || {};
  return markers as SnapshotMarker[];
};

type QueryFnType = typeof getMarkers;

type UseMarkerOptions = {
  snapshotId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useMarkers = ({ snapshotId, config }: UseMarkerOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['snapshot', snapshotId, 'markers'],
    queryFn: () => getMarkers({ snapshotId }),
  });
};
